import React, { useState, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import Loader from '../components/Loader';
import Modal from '../components/Modal';
import FoodModalContent from '../components/FoodModalContent';
import styles from '../styles/pages/_FoodPage.module.scss';
import { fetchFood } from '../api/api';
import FoodCard from '../components/FoodCard';
import SEO from '../components/SEO';
import Billetterie from '../components/Billetterie';
import EventListAlpha from '../components/EventListAlpha';
const FOOD_TYPES = {
  '🥟': 'Asiatique',
  '🍔': 'Burger',
  '🍲': 'Traditionnel'
};

const FoodPage = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedFood, setSelectedFood] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState('all');

  const { data: foods = [], isLoading } = useQuery({
    queryKey: ['foods'],
    queryFn: fetchFood,
    staleTime: 5 * 60 * 1000,
  });

  const filteredFoods = useMemo(() => {
    if (selectedFilter === 'all') return foods;
    return foods.filter(food => food.acf?.type === selectedFilter);
  }, [foods, selectedFilter]);

  const availableTypes = useMemo(() => {
    const types = new Set(foods.map(food => food.acf?.type));
    return Object.fromEntries(
      Object.entries(FOOD_TYPES).filter(([emoji]) => types.has(emoji))
    );
  }, [foods]);

  const getCardOrientation = () => windowWidth > 768 ? 'vertical' : 'horizontal';
  const getCardHeight = () => windowWidth > 768 ? '400px' : '130px';
  
  const handleCardClick = (food) => {
    setSelectedFood(food);
    setModalOpen(true);
  };

  if (isLoading) return <Loader />;
  if (!foods.length) return <div className={styles.noFoods}>Aucun restaurant disponible.</div>;

  return (
    <main className={styles.foodPage}>
      <SEO 
        title="Food & Drinks"
        description="Bienvenue au Poney Festival - Le festival qui vous fera vibrer"
        url="/food"
      />
      
      <section className={styles.titleSection}>
        <h1>Food & Drinks</h1>
        <p>Découvrez une sélection gourmande de restaurants et food trucks pour satisfaire toutes vos envies durant le festival.</p>
      </section>
  
      

      <div className={styles.content}>
        <div className={styles['event-list']}>
          {filteredFoods.map((food) => (
            <div 
              key={food.id}
              className={styles['event-card-wrapper']}
            >
              <FoodCard
                mainImage={food.acf?.image?.url}
                title={food.title}
                typePerformance={food.acf?.type}
                description={food.acf?.description}
                orientation={getCardOrientation()}
                height={getCardHeight()}
                imagePosition="left"
                tags={food.acf?.specialites?.split(',')}
                showOverlay={true}
                onClick={() => handleCardClick(food)}
                cardColor="#fff"
                logoImage={food.acf?.logo?.url}
                theme="light"
              />
            </div>
          ))}
        </div>
      </div>

      <Modal 
        isOpen={isModalOpen} 
        onClose={() => {
          setModalOpen(false);
          setTimeout(() => setSelectedFood(null), 300);
        }}
      >
        {selectedFood && <FoodModalContent 
          food={selectedFood} 
          onClose={() => {
            setModalOpen(false);
            setTimeout(() => setSelectedFood(null), 300);
          }}
        />}
      </Modal>
      <EventListAlpha/>
      <Billetterie/>
    </main>
  );
};

export default FoodPage;